module.exports = __webpack_public_path__ + "img/house-signal.e009cb0e.svg";